<template>
    <router-view />
</template>

<script>
    import router from './router';

    export default {
        name: 'App',
        router,
        data() {
            return {
                routesPublic: ['Register', 'Remember', 'Recover', 'Login', 'Authorize', 'Verify', 'UiComponents'],
                routesNoPrivate: ['Register', 'Login'],
                controlRefresh: false,
            };
        },
        created() {
            this.$session.on('update:user', () => {
                this.$changeLanguage(this.$session.getLang());
                this.$changeMetric(this.$session.getMetric());
            });

            //this.$session.on('login', () => this.controlMqtt());
            //this.$session.on('logout', () => this.controlMqtt());
            //this.$session.on('setTokens', () => this.setHeaderApi());
            this.$session.on('setAwsCredential', () => this.controlMqtt(true));

            this.$api.interceptors.request.use((request) => {
                if (this.$session.isLoged())
                    request.headers['Authorization'] = `Bearer ${this.$session.getAccessToken()}`;
                request.headers['Content-Language'] = this.$lang;
                return request;
            });

            this.$api.interceptors.response.use(undefined, async (error) => {
                if (
                    this.$session.isLoged() &&
                    error.response &&
                    error.response.status === 401 &&
                    error.config &&
                    !error.config.__isRetryRequest
                ) {
                    try {
                        await this.refreshTokens();
                    } catch (authError) {
                        return Promise.reject(error); // refreshing has failed, but report the original error, i.e. 401
                    }
                    error.config.__isRetryRequest = true;
                    return this.$api.axios(error.config); // retry the original request
                }
                return Promise.reject(error);
            });
        },
        methods: {
            routeControl: function() {
                if (this.$route.name == null) {
                    if (this.$session.isLoged()) this.$router.push({ name: 'Dashboard' });
                    else this.$router.push({ name: 'Login' });
                } else if (this.$session.isLoged()) {
                    if (this.routesNoPrivate.includes(this.$route.name)) this.$router.push({ name: 'Dashboard' });
                } else if (!this.routesPublic.includes(this.$route.name)) this.$router.push({ name: 'Login' });
            },

            refreshTokens() {
                if (!this.controlRefresh) {
                    this.controlRefresh = true;

                    return this.$api.refreshTokens(
                        this.$session.getRefreshToken(),
                        (data) => this.$session.setTokens(data.entity),
                        () => {
                            this.$session.logout();
                            this.routeControl();
                        },
                        () => (this.controlRefresh = false)
                    );
                } else {
                    return new Promise((resolve) => {
                        this.checkControlRefresh(resolve);
                    });
                }
            },

            checkControlRefresh(callback) {
                if (this.controlRefresh) setTimeout(() => this.checkControlRefresh(callback), 50);
                else callback();
            },

            // setHeaderApi: function() {
            //     this.$api.headers['Authorization'] = `Bearer ${this.$session.getAccessToken()}`;
            // },

            controlMqtt(reconect) {
                if (!this.$session.isLoged() || this.routesPublic.includes(this.$route.name)) this.$mqtt.disconect();
                else {
                    this.$uniqueSetTimeout(
                        'controlMqtt',
                        () => this.$api.refreshAwsCredentials((data) => this.$session.setAwsCredential(data.entity)),
                        this.$session.getMqttExpirationTime()
                    );

                    if (this.$session.getMqttExpirationTime() > 0) {
                        let credential = this.$session.getAwsCredential();
                        if (reconect) this.$mqtt.reconnect(credential);
                        else this.$mqtt.connect(credential);
                    }
                }
            },
        },
        watch: {
            $route: {
                immediate: true,
                handler() {
                    this.$store.commit('clear');
                    this.routeControl();
                    this.controlMqtt(false);
                    this.$changeLanguage(this.$session.getLang());
                    this.$changeMetric(this.$session.getMetric());
                    this.$forceUpdate();
                },
            },
        },
    };
</script>
